export default function FinalCTA() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-2xl overflow-hidden relative h-[300px] md:h-[380px] mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20lifestyle%20scene%20with%20curated%20fashion%20accessories%20and%20textiles%20artistically%20displayed%20on%20neutral%20surface%2C%20soft%20gentle%20natural%20lighting%20with%20subtle%20vignette%2C%20editorial%20catalog%20aesthetic%2C%20minimalist%20elegant%20composition%2C%20warm%20cream%20and%20sand%20tones&width=1600&height=760&seq=cta-visual-v4&orientation=landscape"
            alt="Start using itaobuy spreadsheet today"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/20"></div>
        </div>

        <div className="text-center max-w-[640px] mx-auto">
          <h2 className="text-[28px] md:text-[36px] font-heading text-foreground-950 leading-[1.3] mb-2">
            Start Using <strong>itaobuyspreadsheet</strong> Today
          </h2>
          <p className="text-[28px] md:text-[36px] font-heading text-foreground-300 font-light italic leading-[1.3] mb-6">
            buy it now
          </p>
          <p className="text-[13px] text-foreground-600 mb-10 leading-relaxed">
            No registration required. Explore structured shopping data instantly across all 14 product categories.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-background-50 text-[15px] font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            buy it now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}